export default __webpack_public_path__ + "static/media/PopupIcons_View_Dealer_Notes_Grey.55d97f21.svg";